import {
  FETCH_GENERATE_LOGIN_LINK_REQUEST,
  FETCH_GENERATE_LOGIN_LINK_SUCCESS,
  FETCH_GENERATE_LOGIN_LINK_FAILURE,
  FETCH_GENERATE_LOGIN_LINK_RESET,
} from '../../constants/ActionTypes';

const generateLoginLink = (
  state = { data: {}, isFetching: false, errors: {} },
  action
) => {
  switch (action.type) {
    case FETCH_GENERATE_LOGIN_LINK_REQUEST:
      return { ...state, data: {}, isFetching: true, errors: {} };
    case FETCH_GENERATE_LOGIN_LINK_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errors: {},
        data: action.data.data,
      };
    case FETCH_GENERATE_LOGIN_LINK_FAILURE:
      return { ...state, data: {}, isFetching: false, errors: action.error };
    case FETCH_GENERATE_LOGIN_LINK_RESET:
      return { ...state, data: {}, isFetching: false, errors: {} };
    default:
      return state;
  }
};

export default generateLoginLink;
